import React from 'react'
import { Icon } from '../../atoms'
import { useEntity } from '../helpers/selectors'
import RichText from '../rich-text-block'

export default (props) => {
  const { badgeTitle, badgeIcon, content } = props
  const contentEntity = useEntity(content)
  return (
    <div className='CardV2'>
      {(badgeTitle || badgeIcon) && (
        <div className='badge'>
          {badgeIcon && (
            <div className='badge__icon'>
              <Icon glyph={badgeIcon} size={32} />
            </div>
          )}
          {badgeTitle && <p className='badge__title'>{badgeTitle}</p>}
        </div>
      )}
      {content && (
        <div className='content'>
          <RichText {...contentEntity} />
        </div>
      )}
    </div>
  )
}
